import useCookie from "./useCookie";

export default useCookie;
